import axios from 'axios';
import type {ContinueChatSession, Message} from 'client';
import {API_URL, isSandboxMode} from 'utilities';

/**
 * Continue a chat session, automatically including sandbox mode if enabled.
 * This is a custom wrapper around the generated OpenAI service to support
 * the is_sandbox query parameter without modifying generated code.
 */
export const continueChatWithSandbox = async (
  sessionId: string,
  requestBody: Message
): Promise<ContinueChatSession> => {
  const sandboxParam = isSandboxMode() ? '?is_sandbox=true' : '';
  const response = await axios.post<ContinueChatSession>(
    `${API_URL}/api/v1/chat/continue/${sessionId}${sandboxParam}`,
    requestBody,
    {withCredentials: true}
  );
  return response.data;
};
